import { Component } from 'react';
import SVGInline from 'react-svg-inline';
import ReactDOM from 'react-dom';

/*
 * Wrapper for SVGInline that removes relative paths from SVGs after DOM insertion
 * to fix Firefox/Safari issues with resolving relative paths in SVG
 */
export default class SVGInlineWithRelativePath extends Component {
  componentDidMount() {
    // Needed when we're using the async React.render method to get the HTML for the SVG
    if (this.props.runImmediately) {
      this.replaceRelativePaths();
    }
    // Run on next run loop to allow state transitions that result in URL changing to complete
    this.timeout = window.setTimeout(this.replaceRelativePaths, 1);
  }

  componentWillUnmount() {
    window.clearTimeout(this.timeout);
  }

  componentDidUpdate = (prevProps) => {
    if (
      prevProps.recalcTrigger !== this.props.recalcTrigger &&
      this.props.recalcTrigger
    ) {
      this.replaceRelativePaths();
    }
  };

  replaceRelativePaths = () => {
    const baseUrl = window.location.href;
    const node = ReactDOM.findDOMNode(this);
    const attrsContainingUrls = ['stroke', 'fill', 'clip-path', 'filter'];
    // Replace relative <use> hrefs
    [...node.querySelectorAll('use[*|href]')].forEach((ele) => {
      ele.setAttribute(
        'xlink:href',
        ele.getAttribute('xlink:href').replace(/(#.+)$/, `${baseUrl}$1`)
      );
    });
    // Replace other attribute values containing urls
    attrsContainingUrls.forEach((attr) => {
      [...node.querySelectorAll(`[${attr}]`)].map((ele) => {
        ele.setAttribute(
          attr,
          ele.getAttribute(attr).replace(/^url\((.+)\)$/, `url(${baseUrl}$1)`)
        );
      });
    });
  };

  render = () => {
    const { recalcTrigger, runImmediately, dataHcName, ...props } = this.props;
    return <SVGInline data-hc-name={dataHcName} {...props} />;
  };
}
